
<!-- <ng-container *ngIf="screenWidth > 768"> -->
  <app-quote-step8-desktop [screenWidth] = "screenWidth" [currentStep] = "currentStep" (onNextStep)= "nextStep()" (onPrevStep)= "prevStep()"></app-quote-step8-desktop>
<!-- </ng-container> -->

<!-- <ng-container *ngIf="screenWidth <= 768">
  <app-quote-step8-mobile [screenWidth] = "screenWidth" [currentStep] = "currentStep" (onNextStep)= "nextStep()" (onPrevStep)= "prevStep()"></app-quote-step8-mobile>
</ng-container> -->